let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fYDoc")).then(() => parcelRequire('jG5BH'));